import { render } from "./BoatSearch.vue?vue&type=template&id=611829d3"
import script from "./BoatSearch.vue?vue&type=script&lang=js"
export * from "./BoatSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__